import ActiveApplications, { renderHeader } from "../active_applications";
import { DashboardSuspense } from "../dashboard_suspense";

const Applications = () => {
  return (
    <div className="active-applications">
      <DashboardSuspense renderHeader={renderHeader}>
        <ActiveApplications />
      </DashboardSuspense>
    </div>
  );
};

export default Applications;
